/**
 * External dependencies
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { omit } from 'lodash';

/**
 * Internal dependencies
 */
import FormTextInput from 'components/forms/form-text-input';
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const FormPasswordInput = (props) => {
    const [hidePassword, setHidePassword] = useState(true);

    const togglePasswordVisibility = () => {
        setHidePassword(!hidePassword);
    };

    const toggleVisibilityClasses = classNames({
        'form-password-input__toggle': true,
        'form-password-input__toggle-visibility': !props.hideToggle,
    });

    return (
        <div className='form-password-input'>
            <FormTextInput
                {...omit(props, 'hideToggle')}
                autoComplete='off'
                type={hidePassword ? 'password' : 'text'}
            />
            <span className={toggleVisibilityClasses} onClick={togglePasswordVisibility}>
                {hidePassword ? <Icon name='FiEyeOff' /> : <Icon name='FiEye' />}
            </span>
        </div>
    );
};

FormPasswordInput.propTypes = {
    isError: PropTypes.bool,
    isValid: PropTypes.bool,
    className: PropTypes.string,
    hideToggle: PropTypes.bool,
};

export default FormPasswordInput;
